export default __webpack_public_path__ + "static/paras2-c07e24c240e670c74729e6f53527b60c.jpg";